import { render, staticRenderFns } from "./AdminViewSearchLog.vue?vue&type=template&id=96f5af5a"
import script from "./AdminViewSearchLog.vue?vue&type=script&lang=js"
export * from "./AdminViewSearchLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports